export default {
    name: 'Pointer',
    dimensions: { width: 40, height: 40 },
    content: `
    <g fill="currentColor" stroke="none">
        <path d="M15.0043 19C12.7943 19 11.0043 17.21 11.0043 15C11.0043 12.79 12.7943 11 15.0043 11C17.2143 11 19.0043 12.79 19.0043 15C19.0043 17.21 17.2143 19 15.0043 19ZM15.0043 9C11.6943 9 9.00427 11.69 9.00427 15C9.00427 18.31 11.6943 21 15.0043 21C18.3143 21 21.0043 18.31 21.0043 15C21.0043 11.69 18.3143 9 15.0043 9Z"/>
        <path d="M15.0043 37.94C12.6743 36.55 2.00427 22.06 2.00427 15C2.00427 7.83 7.83427 2 15.0043 2C22.1743 2 28.0043 7.83 28.0043 15C28.0043 22.06 17.3343 36.55 15.0043 37.94ZM15.0043 0C6.73427 0 0.00427246 6.73 0.00427246 15C0.00427246 19.78 4.04427 26.73 6.44427 30.44C7.08427 31.42 12.7043 40 15.0043 40C17.3043 40 22.9243 31.42 23.5643 30.44C25.9643 26.73 30.0043 19.78 30.0043 15C30.0043 6.73 23.2743 0 15.0043 0Z"/>
    </g>
  `
};

